import React, { Component, Fragment } from 'react';
import NotificationSystem from 'react-notification-system';
import { _delete, get, postWithHeaders, put, post } from '../../../server/actions';
import moment from 'moment';
import ApplicationSettingDisplay from './applicationSettingDisplay';
import PropTypes from 'prop-types';
import { formatResponse, formatHouseholdAppsVerifyResponse, calculateCounts, selectedRowUpdatedObj, getSamplingTypeLabel } from './utils';
import { _addNotification, _addNotificationError, showFile } from '../../../server/util';
import { getCalendarSchoolYear } from '../../../server/utilDistrict';
import ApplicationSelection from './applicationSelection';
import { ConfirmDialog } from './../../Misc/confirmDialog';
import ApplicationVerificationUpdate from './applicationVerificationUpdate';
import NotesAndDocuments from './notesAndDocuments';
import ReportPage from '../Applications/reportPage';

const ApplicationVerificationStatus = {
    PREPARE: 'prepare',
    SELECT: 'select',
    VERIFY: 'verify',
    REPORT: 'report',
    CLOSE: 'close'
};
const ApplicationVerificationStatusText = {
    PREPARE: { text: 'Prepare', orderBy: 0 },
    SELECT: { text: 'Select', orderBy: 1 },
    VERIFY: { text: 'Verify', orderBy: 2 },
    //REPORT: { text: 'Report', orderBy: 3 }
}

class ApplicationVerification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAppSettingWindow: false,
            applicationServiceReq: {},
            applicationSettingsData: {
                schoolList: [],
                status: ApplicationVerificationStatus.PREPARE,
            },
            selectedRow: {},
            isNotesDialogOpen: false,
            householdApplications: [],
            applications: [],
            summaryData: {},
            applicationListData: [],
            notesAndDocument: { notes: [], documents: [] },
            selectedRows: [],
            schoolYear: getCalendarSchoolYear(),
            reportResultData: {},
            continueLoading: false,
            isVerifiedOver: new Date() > new Date(`${getCalendarSchoolYear()}-11-30`),
            householdVerify: {
                householdAppsToVerify: [],
                originalData: [],
                errorProneCount: 0,
                caseCount: 0,
                incomeCount: 0,
                totalCount: 0,
                currentStatusFree: 0,
                newStatusFree: 0,
                currentStatusReduced: 0,
                newStatusReduced: 0,
                currentFilter: 'all',
                responseReceived: 0,
                pendingResponses: 0
            }

        }
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.getApplicationsListData('all');
    }
    componentWillMount = () => {
        this.props.changeShowHideSchoolFitler(false);
        const loggedInUserDetails = JSON.parse(sessionStorage.getItem('loggedInUserDetails'));

        if (loggedInUserDetails && loggedInUserDetails.schools) {
            const schoolsObject = loggedInUserDetails.schools;

            const schoolsArray = Object.keys(schoolsObject).map(schoolId => ({
                schoolId: schoolsObject[schoolId].schoolId,
                schoolName: schoolsObject[schoolId].schoolName,
                selected: false
            }));
            const _applicationSettingsData = this.state.applicationSettingsData;
            _applicationSettingsData.schoolList = schoolsArray;

            this.setState({ applicationSettingsData: _applicationSettingsData });
        }
        this.getSettingsInfo();
    }
    getSettingsInfo = async () => {
        const { applicationSettingsData, schoolYear } = this.state;
        let districtId = sessionStorage.getItem('districtId');
        let verificationYear = schoolYear;
        get(`/householdAppVerifySetup/${districtId}/${verificationYear}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let selectedSchools = data.includedSchools.split(',');
            selectedSchools.map(id => {
                const idx = applicationSettingsData.schoolList.findIndex(s => {
                    return id == s.schoolId;
                });
                if (idx > -1) {
                    applicationSettingsData.schoolList[idx].selected = true;
                }
            })

            const _applicationSettingsData = {
                ...applicationSettingsData,
                name: data.name,
                email: data.email,
                phone: data.contactNo,
                isEmail: data.followupCommTypeEmail,
                isSms: data.followupCommTypeSMS,
                startDate: data.verificationStartDate,
                endDate: data.verificationEndDate,
                status: data.status == undefined ? ApplicationVerificationStatus.PREPARE : data.status,
                isVerifiedOver: moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD') > moment(data.verificationEndDate, 'YYYY-MM-DD'),
                samplingType: data.samplingType,
                followupFrequency: data.followupFrequency,
                currentFilter: 'all'
            };
            this.setState({ applicationSettingsData: _applicationSettingsData, applicationServiceReq: data });

            if (data.status == ApplicationVerificationStatus.SELECT) {
                this.getHouseholdAppsFromSampling();
                this.getApplications();
            }
            else if (data.status == ApplicationVerificationStatus.VERIFY) {
                //this.getHouseholdAppsToVerify()
                this.getApplicationsListData();
                this.getSummaryApplicationData();
                this.getNotesAndDocumentsData();
            } else if (data.status == ApplicationVerificationStatus.REPORT) {
                this.downloadVerifiedReport(false);
            }
        }).catch((error) => {
            console.log('API request failed. Check query params', error);
            this.setState({ loading: false })
        })
    }
    getHouseholdAppsToVerify = async () => {
        let districtId = sessionStorage.getItem('districtId');
        const { schoolYear } = this.state;
        await get(`/householdApplicationToVerify/${districtId}/${schoolYear}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let reviewData = formatHouseholdAppsVerifyResponse(data);
            let countObj = calculateCounts(reviewData);
            this.setState({
                householdVerify: {
                    householdAppsToVerify: reviewData,
                    originalData: reviewData,
                    totalCount: countObj.totalCount,
                    errorProneCount: countObj.errorProneCount,
                    caseCount: countObj.caseCount,
                    incomeCount: countObj.incomeCount,
                    currentStatusFree: countObj.currentStatusFree,
                    currentStatusReduced: countObj.currentStatusReduced,
                    newStatusFree: countObj.newStatusFree,
                    newStatusReduced: countObj.newStatusReduced,
                    responseReceived: countObj.responseReceived,
                    pendingResponses: countObj.pendingResponses,
                    currentFilter: 'all'
                }
            });
        }).catch((error) => {
            console.log('API request failed. Check query params', error);
            this.setState({ loading: false })
        })
    }
    getHouseholdAppsFromSampling = async () => {
        const { applicationSettingsData, schoolYear, householdVerify } = this.state;
        const { schoolList } = applicationSettingsData;
        let districtId = sessionStorage.getItem('districtId');
        let verificationYear = schoolYear
        await get(`/householdAppFromSampling/${districtId}/${verificationYear}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let householdAppsList = formatResponse(data, schoolList, 'getHouseholdApps')
            this.setState({ householdVerify: { ...householdVerify, householdAppsToVerify: householdAppsList }});
        }).catch((error) => {
            console.log('API request failed. Check query params', error);
            this.setState({ loading: false })
        })

    }
    getSummaryApplicationData = async () => {
        let districtId = sessionStorage.getItem('districtId');
        const { schoolYear } = this.state;
        await get(`/verification/summary/${districtId}/${schoolYear}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({
                summaryData: data,
                loading: false
            })             
        }).catch(
            (error) => {  
                this.setState({loading: false});              
                console.log('Get summary data response', error)
            }
        );
    }

    getApplicationsListData = async (filter = 'all') => {
        let districtId = sessionStorage.getItem('districtId');
        const { schoolYear } = this.state;
        let filterOpt = ''
            if(filter != 'all'){
                filterOpt = `filter=${filter}&`
            }
        await get(`/verification/applications/${districtId}/${schoolYear}?${filterOpt}access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({ applicationListData: data })
        }).catch((error) => {
            console.log('API request failed. Check query params', error);
            this.setState({ loading: false })
        })
    }

    getApplications = async () => {
        const { applicationSettingsData } = this.state;
        const { schoolList } = applicationSettingsData;
        let districtId = sessionStorage.getItem('districtId');
        let schoolYear = 0
        await get(`/getHouseholdAppForVerification/?mealSchoolId=0&schoolYear=${schoolYear}&districtId=${districtId}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let applicationList = formatResponse(data, schoolList, 'getApplications')
            this.setState({ applications: applicationList })
        }).catch((error) => {
            console.log('API request failed. Check query params', error);
            this.setState({ loading: false })
        })

    }
    handleNextTabClick = (currentStatus) => {
        if (currentStatus == ApplicationVerificationStatus.SELECT) {
            ConfirmDialog('_dialog1', 'Confirmation Alert', 'Are you sure you want to continue applicaton verification process?', 'Ok', 'Cancel', (res) => {
                if (res) {
                   // this.handleVerify(currentStatus);
                    this.setState(
                        { continueLoading: true },
                        () => {
                            this.handleVerify(currentStatus);
                        }
                    );
                }
            });
        }
    }
    handleVerify = async (currStatus) => {
        const { applicationServiceReq } = this.state;
            let headers = {
                'Content-Type': 'application/json'
            };
            let districtId = sessionStorage.getItem('districtId');
            const requestBody = {
                ...applicationServiceReq,
                'status': currStatus
            };
            try {
            const response = await postWithHeaders(`/householdAppVerifySetup/${districtId}?access_token=`, JSON.stringify(requestBody), headers);
            if (!response.ok) {
                throw Error(response.statusText || response.status);
            }

            this.setState({ status: currStatus });
            if (currStatus == ApplicationVerificationStatus.SELECT) {
                _addNotification('Verification Setup has been updated successfully.', this);
            }
            await this.getSettingsInfo();
            return true;
           } catch (error) {
            _addNotificationError(`Failed to verify household apps! Getting ${error} status. Please check API request`, this);
            return false;
          } finally {
            this.setState({ loading: false, continueLoading: false });
        }
    }
    downloadHouseholdVerifyAppReport = async () => {
        const { schoolYear } = this.state;
        let districtId = sessionStorage.getItem('districtId');
        await get(`/reports/householdAppVerifyStudentExportReport/${districtId}/${schoolYear}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.blob();
        }).then(blob => {
            // Create a link element and trigger a click to download the file
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = 'HouseholdAppVerifyStudentReport.xls'; // You can set the desired filename here
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            // Optionally, you can clean up the URL.createObjectURL
            URL.revokeObjectURL(a.href);
            console.log("Report downloaded successfully.")
        }).catch((error) => {
            console.log('API request failed. Check query params', error);
            this.setState({ loading: false })
        })
    }
    postHouseholdAppsToVerify = async (isContinue = false) => {
        if (this.state.householdVerify.householdAppsToVerify.length > 0) {
            this.setState(isContinue ? { continueLoading: true } : { loading: true });
            let requestBody = this.state.householdVerify.householdAppsToVerify;
            let currentYear = this.state.schoolYear;
            let districtId = sessionStorage.getItem('districtId');
            let headers = {
                'Content-Type': 'application/json'
            };
            let modifiedRequestBody = requestBody.map(item => {
                const { errorProne, schoolName, studentName, ...rest } = item
                return rest
            })

            // Post method to send data to backend
            try {
                const response = await postWithHeaders(`/householdApplicationToVerify/${districtId}/${currentYear}?access_token=`, JSON.stringify(modifiedRequestBody), headers);
                if (!response.ok) {
                    throw Error(response.statusText || response.status);
                }

                this.setState({ selectedRows: [] });
                _addNotification('Application has been saved successfully.', this);

                if (isContinue) {
                    await this.handleVerify(ApplicationVerificationStatus.VERIFY);
                }
              } catch (error) {
                _addNotificationError(`Failed to verify household apps! Getting ${error} status. Please check API request`, this);
             } finally {
                this.setState({ loading: false, continueLoading: false });
            }
        }
    }
    updateHouseholdAppsToVerify = async (row, field, fieldValue) => {
        let message = '';
        let secondConfirmMessage = "";
        if (field == "confirmOfficialSign") {
            message = "Are you sure you want to update confirm official signature stauts?";
            secondConfirmMessage = "Confirming the official signature status updateing. Are you sure you want to proceed?";
        } else if (field == "directVerification") {
            message = "Are you sure you want to update direct verification stauts?";
            secondConfirmMessage = "Direct verification status updateing. Are you sure you want to proceed?";

        } else if (field == "verificationLetterSent") {
            message = "Are you sure you want to update verification letter sent stauts?";
            secondConfirmMessage = "Verification letter status updateing. Are you sure you want to proceed?";

        } else if (field == "newEligibility") {
            message = "Are you sure you want to update new eligibility?";
            secondConfirmMessage = "Updating new eligibility. Are you sure you want to proceed?";

        } else if (field == "documentsVerified") {
            message = "Are you sure you want to update documents verified status?";
            secondConfirmMessage = "Documents verifified status updating. Are you sure you want to proceed?";

        } else {
            message = `Are you sure you want to update '${field}' field value?`;
            secondConfirmMessage = "Updating " + field + " value. Are you sure you want to proceed?";
        }

        if (field === 'notes') {
            message = 'Are you sure you want to add the notes?'
            secondConfirmMessage = "Adding the new notes. Are you sure you want to proceed?";
        }

        if (field === 'documents') {
            message = 'Are you sure you want to upload the document?';
            secondConfirmMessage = "Uploading the document. Are you sure you want to proceed?";
        }
        ConfirmDialog('_dialog1', 'Confirmation Alert', message, 'Ok', 'Cancel', (res) => {
            if (res) {
                ConfirmDialog('_dialog2', 'Confirmation Alert', secondConfirmMessage, 'Ok', 'Cancel', (secRes) => {
                    if (secRes) {
                        // const shouldProceed = window.confirm(message);
                        // if (shouldProceed) {
                        this.setState({ loading: true })
                        let requestBody = row._original
                        if (field === 'documentsVerified') {
                            requestBody[field] = fieldValue === 'Verified' ? true : false
                            requestBody['status'] = fieldValue
                        } else if (field === 'notes' || field === 'documents') {
                            requestBody = row
                        } else {
                            requestBody[field] = fieldValue
                        }
                        let districtId = sessionStorage.getItem('districtId');
                        const data = new FormData();
                        data.append('body', JSON.stringify(requestBody));
                        if (field === 'documents') {
                            data.append('file', fieldValue)
                        }
                        put(`/householdApplicationToVerify/${districtId}?access_token=`, data).then((response) => {
                            if (response.status === 200) {
                                this.getHouseholdAppsToVerify();
                                let fieldText = '';

                                if (field == "confirmOfficialSign") {
                                    fieldText = "Confirm official signature stauts";
                                } else if (field == "directVerification") {
                                    fieldText = "Direct verification stauts";

                                } else if (field == "verificationLetterSent") {
                                    fieldText = "Verification letter sent stauts";

                                } else if (field == "newEligibility") {
                                    fieldText = "New eligibility";

                                } else if (field == "documentsVerified") {
                                    fieldText = "Documents verified status";

                                } else {
                                    fieldText = `${field}`;
                                }
                                _addNotification(`${fieldText} has been updated successfully.`, this);
                                return response.json()
                            } else if (!response.ok) {
                                throw Error(response.status);
                            } else {
                                _addNotificationError('Check your request body', this);
                            }
                        }).then(data => {
                            if (field === 'notes' || field === 'documents') {
                                const updatedRow = selectedRowUpdatedObj(data)
                                this.openNotesDialog(updatedRow)
                            }
                        }).catch(
                            (error) => {
                                this.setState({ loading: false })
                                _addNotificationError(`Failed to Update! Getting ${error} status. Please check API request`, this);
                            }
                        );
                    }
                });

            } else {
                console.log("field name: ", field)
                console.log("value: ", fieldValue)
                console.log("row: ", row)
            }
        });
    }

    resetApplicationPrcoess = () => {
        const _self = this;
        let districtId = sessionStorage.getItem('districtId');
        const verificationYear = this.state.schoolYear;
        _delete(`/householdApplicationToVerify/${districtId}/${verificationYear}?active=false&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
            .then(data => {
                _addNotification('Application verfication process restarted successfully', this);
                this.getSettingsInfo();
            })
            .catch(
                (error) => {
                    _addNotificationError('Application verfication process restarted failed. Please try again later.', this);
                }
            )
    }
    downloadVerifiedReport = (isPdf) => {
        const _self = this;
        let districtId = sessionStorage.getItem('districtId');
        const verificationYear = this.state.schoolYear;
        get(`/householdApplicationToVerifyDashboard/${districtId}/${verificationYear}?isExport=${isPdf}&access_token=`).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                if (isPdf) {
                    return res.blob();
                } else {
                    return res.json();
                }
            }
        }).then(data => {
            if (isPdf) {
                let filename = 'VerificationReport.pdf';
                showFile(data, filename);
                this.setState({ loading: false });
            } else {
                this.setState({
                    reportResultData: data
                })
            }
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                //console.log('Get Excel File response', error)
                this.setState({ loading: false })
            }
        );

    }
    renderApplicationSettingsDisplay = () => {
        const { applicationSettingsData } = this.state;
        const { status } = applicationSettingsData;
        return <Fragment> <div className='row'>
            <div className='col-md-offset-2 col-md-8'>
                <ApplicationSettingDisplay {...{ applicationSettingsData, ApplicationVerificationStatusText }} />
            </div>
        </div>
            <div className='row'>
                <div className='col-md-6 text-left'><button className='btn btn-sm btn-primary' onClick={() => {
                    this.context.router.history.push(`/district/applicationSetting`);

                }}>Edit Settings</button></div>
                <div className='col-md-6 text-right'><button className='btn btn-sm btn-primary' onClick={() => {
                    this.handleNextTabClick(ApplicationVerificationStatus.SELECT);
                }}
                 disabled={this.state.continueLoading}> 
                 {this.state.continueLoading ? (
                        <i className="fa fa-spinner fa-spin"></i>
                    ) : (
                        'Go To Select'
                    )}</button>
                </div>
            </div>
        </Fragment>
    }
    renderApplicationSelection = () => {
        const { householdVerify, applications, selectedRows } = this.state;
        return <Fragment> <div className='row'>
            <div className='col-md-12'>
                <ApplicationSelection {...{
                    applications,
                    householdApplications: householdVerify.householdAppsToVerify,
                    selectedRows,
                    deleteFromSelectedList: (row) => {
                        ConfirmDialog('_dialog1', 'Confirmation Alert', 'Are you sure you want to delete the selected application [App.Id=' + row.applicationId + ']?', 'Ok', 'Cancel', (res) => {
                            if (res) {
                                const _householdApplications = householdVerify.householdAppsToVerify;
                                const idx = _householdApplications.findIndex(a => a.applicationId == row.applicationId);
                                if (idx > -1) {
                                    _householdApplications.splice(idx, 1);
                                    this.setState({ householdVerify: { ...householdVerify, householdAppsToVerify: [..._householdApplications] } });
                                }
                            }
                        });
                    },
                    unSelectFromSelectedList: (row) => {
                        const updatedSelectedRows = selectedRows.filter(
                            r => r.applicationId !== row.applicationId
                        );
                        const updatedHouseholdApplications =
                            householdVerify.householdAppsToVerify.filter(
                                r => r.applicationId !== row.applicationId
                            );
                        this.setState({
                            selectedRows: updatedSelectedRows,
                            householdVerify: {
                                ...householdVerify,
                                householdAppsToVerify: updatedHouseholdApplications
                            }
                        });
                    },
                    onSelectApplication: (row) => {
                            const exists = selectedRows.some(
                                r => r.applicationId === row.applicationId
                            );
                            if (!exists) {
                                this.setState({
                                    selectedRows: [
                                        ...selectedRows,
                                        { ...row }
                                    ]
                                });
                            }
                        },
                        onAddSelectedApplications: () => {
                                const existingApplications =
                                    householdVerify.householdAppsToVerify || [];
                                const newApplications = selectedRows.filter(
                                    selectedRow =>
                                        !existingApplications.some(
                                            application =>
                                                application.applicationId === selectedRow.applicationId
                                        )
                                );
                                this.setState({
                                    selectedRows: [],
                                    householdVerify: {
                                        ...householdVerify,
                                        householdAppsToVerify: [
                                            ...existingApplications,
                                            ...newApplications
                                        ]
                                    }
                                });
                            },
                    onCancelSelectedApps: () => {
                        this.setState({ selectedRows: [] });
                    }
                }} />
            </div>
        </div>
            <div className='row'>
                {/* <div className='col-md-6 text-left'>
                    <button className='btn btn-sm btn-primary' onClick={() => {
                    }}>Back</button>
                </div> */}
                <div className='col-md-12 text-right'>
                    <button className='btn btn-sm btn-primary' onClick={this.downloadHouseholdVerifyAppReport}>
                        <i className='fa fa-download'></i> Download
                    </button>
                    <button className={`btn btn-sm btn-primary`} onClick={() => this.postHouseholdAppsToVerify(false)}
                            disabled={this.state.loading}
                            >
                        <i className={this.state.loading ? 'fa fa-spinner fa-spin' : 'fa fa-floppy-o'}></i> Save
                    </button>
                    <button className='btn btn-sm btn-primary' onClick={() => {
                        ConfirmDialog('_dialog1', 'Confirmation Alert', 'Are you sure you want to continue applicaton verification process?', 'Ok', 'Cancel', (res) => {
                             if (res) {
                                this.postHouseholdAppsToVerify(true);
                            }
                        });
                        //this.handleNextTabClick(ApplicationVerificationStatus.SELECT);
                      }}
                      disabled={this.state.continueLoading}> Continue
                          {this.state.continueLoading ? (
                             <i className="fa fa-spinner fa-spin"></i>
                         ) : (
                             null
                         )}
                     </button>
                </div>
            </div>
        </Fragment>
    }
    getSelectedApplicationContext = (row) => {
        if (!row) {
            return this.state.selectedRow || {};
          }
        if (row._original) {
            return row._original;
        }
        return row;
    };

    getApplicationVerifyId = (row) => {
        const application = this.getSelectedApplicationContext(row);
        return application.verifyId || application.verificationId || application.id || null;
    };

    openNotesDialog = (row) => {
        const selectedApplication = this.getSelectedApplicationContext(row);
        this.setState({
            selectedRow: selectedApplication,
            isNotesDialogOpen: true,
              }, () => {
            this.getNotesAndDocumentsData();
        });
    };

    closeNotesDialog = () => {
        this.setState({
            selectedRow: {},
            isNotesDialogOpen: false,
        });
    };
   addNotesAndDocuments = (field, value) => {
       let message = '';
       let secondConfirmMessage = '';
        if (field === 'notes') {
            message = 'Are you sure you want to add the notes?';
            secondConfirmMessage = 'Adding the new notes. Are you sure you want to proceed?';
        }
        if (field === 'documents') {
            message = 'Are you sure you want to upload the document?';
            secondConfirmMessage = 'Uploading the document. Are you sure you want to proceed?';
        }
        ConfirmDialog(
            '_dialog1',
            'Confirmation Alert',
            message,
            'Ok',
            'Cancel',
            (res) => {
                if (!res) return;
                ConfirmDialog(
                    '_dialog2',
                    'Confirmation Alert',
                    secondConfirmMessage,
                    'Ok',
                    'Cancel',
                    (secRes) => {
                       if (!secRes) return;
                          this.setState({ loading: true });
                    // -------------------------
                    // Add Notes API
                    // -------------------------
                    if (field === 'notes') {
                        const verifyId = this.getApplicationVerifyId(this.state.selectedRow);
                        const headers = {
                            "Content-Type": "application/json"
                           };
                        const requestBody = {
                                  notes: value
                            };
                        postWithHeaders( `/verification/notes/${verifyId}?access_token=`, JSON.stringify(requestBody), headers
                        ).then((response) => {
                            if (response.status === 200) {
                                _addNotification( "Notes added successfully.",this);
                            this.setState( {  loading: false },
                            () => {
                                this.getNotesAndDocumentsData();
                            }
                          );
                                return;
                            }
                            throw Error(response.errorMessage);
                        })
                        .catch(error => {
                            this.setState({loading:false, isNotesDialogOpen:false });
                            _addNotificationError(`Data truncation: Data too long for column 'notes' at row 1`, this  );
                        });
                    }
                    // -------------------------
                    // Upload Documents API
                    // -------------------------
                    if (field === 'documents') {
                    const verifyId = this.getApplicationVerifyId(this.state.selectedRow);
                    const formData = new FormData();
                    formData.append("file", value );
                    post( `/verification/documents/${verifyId}?access_token=`, formData ).then(response => {
                        if(response.status === 200){
                            _addNotification("Document uploaded successfully.", this );
                             this.setState( {  loading: false},
                                    () => {
                                        this.getNotesAndDocumentsData();
                                    }
                                );
                            return;
                        }
                        throw Error(response.userMessage);
                    })
                    .catch(error=>{
                        this.setState({ loading:false });
                        _addNotificationError( `Verification is locked; documents cannot be uploaded".`, this );
                    });
                }
              }
           );
          }
        );
       };
    getNotesAndDocumentsData = async () => {
        const verifyId = this.getApplicationVerifyId(this.state.selectedRow);
            if (!verifyId) {
                this.setState({ notesAndDocument: { notes: [], documents: [] }, loading: false });
                return;
            }
            await get(`/verification/${verifyId}/notes-documents?access_token=`).then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response.json();
                }).then(data => {
                        const notes = data.filter(item => item.inputType === "note");
                        const documents = data.filter(item => item.inputType === "document");
                        this.setState({notesAndDocument: { notes, documents },
                            loading: false
                        });
                    }).catch(
                    (error) => {  
                        this.setState({loading: false});              
                        console.log('Get notes and documents data response', error)
                    }
                );
            }
   
    filter = (filterType) => {
        this.setState(prevState => ({
            householdVerify: {
                ...prevState.householdVerify,
                currentFilter: filterType
            }
        }));
      this.getApplicationsListData(filterType);
    };
    
   renderVerifyHeader = () => {
    const { applicationSettingsData, householdVerify, summaryData } = this.state;
    return (
        <div className="row" style={{ marginBottom: '15px' }}>
            <div className="col-md-3">
                <div style={{backgroundColor: '#FEF6EA', borderRadius: '10px'}}>
                    <div className="panel-body">
                        <div style={{ color: '#777', textAlign: 'center' }}>
                            Sampling Type
                        </div>
                        <h4 style={{ textAlign: 'center' }}>
                            {getSamplingTypeLabel(summaryData.samplingType)}
                        </h4>
                    </div>
                </div>
            </div>

            <div className="col-md-3">
                <div style={{backgroundColor: '#FEF6EA', borderRadius: '10px'}}>
                    <div className="panel-body">
                        <div style={{ color: '#777', textAlign: 'center' }}>
                            Sample Size
                        </div>
                        <h4 style={{ textAlign: 'center' }}>
                            {summaryData.sampleSize} / {summaryData.selectedApplications} apps
                        </h4>
                    </div>
                </div>
            </div>

            <div className="col-md-3">
                <div style={{backgroundColor: '#FEF6EA', borderRadius: '10px'}}>
                    <div className="panel-body">
                        <div style={{ color: '#777', textAlign: 'center' }}>
                            Responded
                        </div>
                        <h4 style={{ textAlign: 'center' }}>
                            {summaryData.respondedCount} / {summaryData.sampleSize}
                        </h4>
                    </div>
                </div>
            </div>

            <div className="col-md-3">
                <div style={{backgroundColor: '#FEF6EA', borderRadius: '10px'}}>
                    <div className="panel-body">
                        <div style={{ color: '#777', textAlign: 'center' }}>
                            Deadline
                        </div>
                        <h4 style={{ textAlign: 'center' }}>
                            {moment(summaryData.deadline).format('MMM DD')}
                        </h4>
                    </div>
                </div>
            </div>

        </div>
    );
}
renderVerifyFilters = () => {
  const { currentFilter } = this.state.householdVerify;
     return (
    <div className="verify-filters" style={{ marginBottom: '10px' }}>
     <div className='btn-group'>
      <button className={currentFilter === 'all' ? "btn btn-xs btn-inactive-color active" : "btn btn-xs btn-inactive-color"}
              onClick={() => this.filter('all')}
      >All</button>
      <button className={currentFilter === 'awaiting' ? "btn btn-xs btn-inactive-color active" : "btn btn-xs btn-inactive-color"}
              onClick={() => this.filter('awaiting')}
      >Awaiting Response</button>
      <button className={currentFilter === 'ready_to_verify' ? "btn btn-xs btn-inactive-color active" : "btn btn-xs btn-inactive-color"}
              onClick={() => this.filter('ready_to_verify')}
      > Ready To Verify</button>
      <button className={currentFilter === 'complete' ? "btn btn-xs btn-inactive-color active" : "btn btn-xs btn-inactive-color"}
              onClick={() => this.filter('complete')}
      > Complete</button>
    </div>
   </div>
  );
}

    renderVerifyApplications = () => {
        const { householdVerify, applicationSettingsData } = this.state;
        return <Fragment>
            {this.renderVerifyHeader()}
            {this.renderVerifyFilters()}
            <div className='row'>
                <div className='col-md-12'>
                    <ApplicationVerificationUpdate 
                    {...(householdVerify || {})} {...{
                        updateHouseholdAppsToVerify: this.updateHouseholdAppsToVerify,
                        openNotesDialog: this.openNotesDialog,
                        applicationListData: this.state.applicationListData,
                         refreshApplications: this.getApplicationsListData
                    }} 
                    />
                </div>
            </div>
            {this.state.isNotesDialogOpen ?
                <NotesAndDocuments onPutApiCall={this.addNotesAndDocuments}
                    selectedRowValues={this.state.selectedRow}
                    notesAndDocumentsData={this.state.notesAndDocument}
                    onClose={this.closeNotesDialog} /> : null
            }
             {/* <div className='col-md-12 text-right pt-3'>
                    <button type='button' disabled={!applicationSettingsData.isVerifiedOver} className={`btn btn-sm btn-primary ${applicationSettingsData.isVerifiedOver ? '' : 'disabled'}`} onClick={() => {
                        ConfirmDialog('_dialog1', 'Confirmation Alert', 'Are you sure you want to close applicaton verification process?', 'Ok', 'Cancel', (res) => {
                            if (res) {
                                if (applicationSettingsData.isVerifiedOver) {
                                    this.handleVerify(ApplicationVerificationStatus.REPORT);
                                }
                            }
                        });
                    }}>Close verification & Report</button>
                </div> */}
        </Fragment>
    }
    renderAppSettingModal = () => {
        const { showAppSettingWindow, applicationSettingsData } = this.state;
        return <Fragment>
            {
                showAppSettingWindow ? <div className="dialog-container" style={{ width: '50%' }}>
                    <div className="dialog-close" onClick={() => {
                        this.setState({ showAppSettingWindow: false })
                    }}>
                        <span>&times;</span>
                    </div>
                    <div className="dialog-title">Application Settings</div>
                    <div className="dialog-tab-content">
                        <ApplicationSettingDisplay {...{ applicationSettingsData, ApplicationVerificationStatusText }} />
                        <div className='row'>
                            <div className='col-md-12 text-right'>
                                <button className='btn btn-sm btn-primary' style={{ margin: '5px' }} onClick={() => {
                                    this.setState({ showAppSettingWindow: false })
                                }}>
                                    Ok
                                </button>
                            </div>
                        </div>
                    </div>
                </div> : null
            }
        </Fragment>
    }
    render() {
        const { applicationSettingsData, reportResultData } = this.state;
        const { status } = applicationSettingsData;
        return (
            <Fragment>
                <section className=" full-width clearfix">
                    <NotificationSystem ref="notificationSystem" />
                    <div className="container-full" style={{ marginTop: '5px', marginBottom: '10px' }}>
                        <div className='row'>
                            <div className='col-md-12 sectionTitle'>
                                <h2>Application Verification</h2>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='panel panel-primary'>
                                    <div className='panel-heading' style={{ background: 'transparent' }}>
                                        <div className='row'>
                                            <div className='col-md-8'>
                                                <ul className="nav nav-pills">
                                                    {
                                                        Object.keys(ApplicationVerificationStatusText).map(keyName => {
                                                            const currentObj = Object.keys(ApplicationVerificationStatusText).map(k => {
                                                                return { ...ApplicationVerificationStatusText[k], keyVal: k }
                                                            }).find(k => {
                                                                return ApplicationVerificationStatus[k.keyVal] == status;
                                                            });

                                                            return <li role="presentation"
                                                                className={(currentObj.orderBy || 0) >= ApplicationVerificationStatusText[keyName].orderBy ? 'active disabled' : 'disabled'}>
                                                                <a href="javascript:void(0)" onClick={() => { return }}>{ApplicationVerificationStatusText[keyName].text}</a>
                                                            </li>
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                            <div className='col-md-4 text-right'>
                                                {
                                                    (status == ApplicationVerificationStatus.SELECT || status == ApplicationVerificationStatus.VERIFY || status == ApplicationVerificationStatus.REPORT) && <Fragment>
                                                        <button className={`btn btn-sm btn-primary`} style={{ margin: '0px' }} onClick={() => {
                                                            this.setState({ showAppSettingWindow: true })
                                                        }}>
                                                            <i className='fa fa-cog'></i> Settings
                                                        </button>
                                                        <button className={`btn btn-sm btn-primary`} style={{ margin: '0px', marginLeft: '5px' }} onClick={() => {
                                                            ConfirmDialog(
                                                                '_dialog1',
                                                                'Confirmation Alert',
                                                                'Are you sure you want to close and restart application verification process from starting?',
                                                                'Ok',
                                                                'Cancel',
                                                                (res) => {
                                                                    if (res) {
                                                                        this.resetApplicationPrcoess();
                                                                    }
                                                                });

                                                        }}> <i className='fa fa-refresh'></i> Restart</button>
                                                    </Fragment>
                                                }
                                            </div>
                                        </div>

                                    </div>
                                    <div style={{ padding: '15px' }}>
                                        {
                                            status == ApplicationVerificationStatus.PREPARE ? this.renderApplicationSettingsDisplay()
                                                : status == ApplicationVerificationStatus.SELECT ? this.renderApplicationSelection()
                                                    : status == ApplicationVerificationStatus.VERIFY ? this.renderVerifyApplications()
                                                        : status == ApplicationVerificationStatus.REPORT ?
                                                            <div className='row'>
                                                                <div className='col-md-12'>
                                                                    <ReportPage data={reportResultData || {}} downloadReport={() => this.downloadVerifiedReport(true)} />
                                                                </div>
                                                            </div> : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        this.renderAppSettingModal()
                    }
                </section>
            </Fragment >
        );
    }
}
ApplicationVerification.contextTypes = {
    router: PropTypes.object.isRequired
}

export default ApplicationVerification;


// WEBPACK FOOTER //
// ./src/components/District/applicationVerification/index.js